import IconServicesAvatar from '../IconServicesAvatar/IconServicesAvatar';
import style from './PaidUserCard.module.css';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import IconStatusAvatar from '../IconStatusAvatar/IconStatusAvatar';
import { selectUserType } from '../../../redux/auth/selectors';

const PaidUserCard = ({ user }) => {
  const userType = useSelector(selectUserType);

  const navigate = useNavigate();
  const handleClick = () => {
    window.scrollTo({
      top: 300,
      behavior: 'smooth', // This makes the scroll smooth
    });
    const url = `${user.name}_from_${user.country}_${user.city}_${user._id}`;

    let typeUser;
    switch (userType) {
      case 'paidUser':
        typeUser = 'man-user';
        break;
      case 'freeUser':
        typeUser = 'free-user';
        break;
      case 'agencyUser':
        typeUser = 'agency-user';
        break;
    }
    navigate(`/${typeUser}/user-profile/${url}`);
  };

  const calculateAge = birthday => {
    const birthDate = new Date(birthday);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust the age if the current date is before the birthday this year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const userAge = calculateAge(user.birthday);
  return (
    <div className={style.card}>
      <img
        src={user?.avatar}
        alt={`${user.name}_from_${user?.country}_${user?.city}`}
        className={style.profileImage}
        onClick={handleClick}
      />
      <IconStatusAvatar
        userId={user._id}
        userBirthday={user.birthday}
        registeredUser={user.registerDate}
        userData={user}
      />
      <IconServicesAvatar user={user} />
      <div className={style.info} onClick={handleClick}>
        <h2 className={style.name}>
          {user?.name} {userAge}
        </h2>
        <p className={style.username}>Nickname: {user?.nickname}</p>
      </div>
    </div>
  );
};

export default PaidUserCard;
